import { useDjRestAuthUserRetrieve } from "@/api/lctApIComponents";
import { useAppSelector } from "./reduxHooks";

export const useGetCurrentUser = () => {
  const token = useAppSelector((state) => state.user.authKey);

  const { data, isLoading } = useDjRestAuthUserRetrieve({ headers: { Authorization: `Token ${token}` } });

  const fullName = `${data?.first_name} ${data?.last_name}`;
  const email = data?.email;
  const isStaff = data?.is_staff;

  return { currentUser: { fullName, email, isStaff }, isLoading };
};
